import lazy from "effects/midi/mappable/lang/lazy.js";
import {isNumber} from "utils/IsNumber.js";
import {doc} from './docs.js';

doc(
    "!",
    {
        n: "Number to compare to",
    },
    "Not boolean",
    () => 1,
    {
        inlets: 1,
        tags: ["Math"]
    }
);
const not = (object) => {
    return (msg) => {
        try {
            let _msg = parseFloat(msg[0]);
            return !_msg;
        } catch (e) {
            return [undefined, "bang"];
        }
    };
};

doc(
    "<",
    {
        n: "Number to compare to",
    },
    "Allows messages to pass if they are less than a given number",
    () => 2,
    {
        inlets: 2,
        tags: ["Math"]
    }
);
const lt = (object, n) => {
    return (msg) => {
        try {
            let _msg = parseFloat(msg[0]);
            return _msg < parseFloat(n()) ? ["bang"] : [undefined, "bang"];
        } catch (e) {
            return [undefined, "bang"];
        }
    };
};


doc(
    ">",
    {
        n: "Number to compare to",
    },
    "Allows messages to pass if they are greater than a given number",
    () => 2,
    {
        inlets: 2,
        tags: ["Math"]
    }
);
const gt = (object, n) => {
    return (msg) => {
        try {
            let _msg = parseFloat(msg[0]);
            return _msg > parseFloat(n()) ? ["bang"] : [undefined, "bang"];
        } catch (e) {
            return undefined;
        }
    };
};

doc(
    "=",
    {
        n: "Number to compare to",
    },
    "Allows messages to pass if they are equal to a given number",
    () => 2,
    {
        inlets: 2,
        tags: ["Math"]
    }
);
export const eq = (object, n) => {
    return (msg) => {
        try {
            let _msg = parseFloat(msg[0]);
            if (_msg === parseFloat(n())) {
                return ["bang"];
            } else {
                return [undefined, "bang"];
            }

        } catch (e) {
            return undefined;
        }
    };
};

doc(
    "<=",
    {
        n: "Number to compare to",
    },
    "Allows messages to pass if they are less than or equal to a given number",
    () => 2,
    {
        tags: ["Math"]
    }
);
export const lte = (object, n) => {
    return (msg) => {
        try {
            let _msg = parseFloat(msg[0]);
            return _msg <= parseFloat(n()) ? ["bang"] : [undefined, "bang"];
        } catch (e) {
            return undefined;
        }
    };
};

doc(
    ">=",
    {
        n: "Number to compare to",
    },
    "Allows messages to pass if they are greater than or equal to a given number",
    () => 2,
    {
        tags: ["Math"]
    }
);
const gte = (object, n) => {
    return (msg) => {
        try {
            let _msg = parseFloat(msg[0]);
            return _msg >= parseFloat(n()) ? ["bang"] : [undefined, "bang"];
        } catch (e) {
            return undefined;
        }
    };
};

doc(
    "&&",
    {
        a: "Number to compare to",
    },
    "Applies logical AND to the arguments",
    undefined,
    {
        inlets: 2,
        tags: ["Math"],
        isHot: true
    }
);
const and = (object, a, b) => {
    return (msg) => {
        if (msg[0] && a()) {
            return ["bang"];
        } else {
            return undefined;
        }
    };
};

doc(
    "||",
    {
        a: "Number to compare to",
    },
    "Applies logical OR to the arguments",
    undefined,
    {
        isHot: true,
        inlets: 2,
        tags: ["Math"],
    }
);
const or = (object, a) => {
    return (msg) => {
        if (a() || msg[0]) {
            return ["bang"];
        } else {
            return undefined;
        }
    };
};




export const comparators = {
    '=': eq,
    '<': lt,
    '>': gt,
    '<=': lte,
    '>=': gte,
    '&&': and,
    '||': or,
    '!': not
};
